import React from 'react';
import GenericDialog from "../dialog/GenericDialog";
import {ViewIllustrationRequestContent} from "./index";


type VRProps = { onViewIllustrationRequest: any; refreshPage: any; setViewIllustrationRequest: any | Function; };
const ViewRequest: React.FC<VRProps> = (props) => {
    const {onViewIllustrationRequest, refreshPage, setViewIllustrationRequest} = props;
    return (
            <>
                <GenericDialog
                        aria-describedby="illustration-change-requested-pop-up"
                        aria-labelledby="Illustration change requested"
                        content={
                            (
                                    <ViewIllustrationRequestContent
                                            refreshPage={refreshPage}
                                            onViewIllustrationRequest={onViewIllustrationRequest}
                                            setViewIllustrationRequest={ setViewIllustrationRequest}
                                    />
                            )
                        }
                        fullWidth
                        maxWidth="sm"
                        onClose={() => setViewIllustrationRequest(false)}
                        open={onViewIllustrationRequest}
                        title="Illustration change requested"
                />
            </>
    );
};


export default ViewRequest;
